import axios, { type AxiosError } from 'axios';

export const LOGOUT_SIGNAL_KEY = 'castvo_admin_logged_out';

let unauthorizedHandler: (() => void) | null = null;

export function setUnauthorizedHandler(handler: () => void) {
  unauthorizedHandler = handler;
}

export const apiClient = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL ?? 'http://localhost:8787',
  timeout: 30_000,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});

apiClient.interceptors.response.use(
  (res) => res,
  (error: AxiosError<{ message?: string }>) => {
    const message = error.response?.data?.message;
    if (message) error.message = message;
    if (error.response?.status === 401 || error.response?.status === 403) {
      unauthorizedHandler?.();
    }
    return Promise.reject(error);
  },
);

window.addEventListener('storage', (event) => {
  if (event.key === LOGOUT_SIGNAL_KEY && event.newValue) {
    unauthorizedHandler?.();
  }
});
